import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  matureJourney,
  immatureJourney,
} from "../journey-breadcrumb/journey-breadcrumb";
import { JourneySearchStore } from "src/app/features/store/journey-search-store";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "progression-bar",
  imports: [TranslocoModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./progression-bar.html",
})
export class ProgressionBar {
  router = inject(Router);

  matureJourney = matureJourney;
  immatureJourney = immatureJourney;

  progressBarSizeInPixel = 170;

  store = inject(JourneySearchStore);
  isJourneyImmature = computed(() => this.store.isJourneyImmature());
  currentJourney = computed(() => {
    return this.isJourneyImmature() ? immatureJourney : matureJourney;
  });

  currentRoute = this.router.url.slice(1);

  currentProgress = computed(() => {
    const currentPage = this.currentJourney().find(
      (page) => page.route === this.currentRoute
    );
    return currentPage ? currentPage.progressPercentage : "0%";
  });

  progressWidth = computed(() => {
    const progressString = this.currentProgress();
    const progressValue = Number.parseFloat(progressString.replace("%", ""));
    return (progressValue / 100) * this.progressBarSizeInPixel;
  });
}
